import { sendScheduleEventConfirmationCommunications } from "../../../../../../../../../../api/kehrblatt/schedule-events"
import type { ConfirmationMailOperations } from "../actions/confirmationMail"

export const confirmationMailOperations: ConfirmationMailOperations = {
  send: sendScheduleEventConfirmationCommunications,
}
